import { AdBanner } from "./AdBanner.js";
import type { ReactNode } from "react";


interface HalfPageAdBannerProps {
    children?: ReactNode;
}


export function HalfPageAdBanner({ children }: HalfPageAdBannerProps) {
    return (
        <AdBanner
            siteID="129640"
            formatID="3"
            className="flex h-full max-w-2xs flex-col items-center overflow-hidden [&_div]:grow-0 [&_p]:mt-auto [&_p]:mb-0 [&_p]:max-w-full">

            {children}
        </AdBanner>
    );
}
